module.exports = __webpack_public_path__ + "img/comments-question.073f784e.svg";